module.exports = __webpack_public_path__ + "static/TakeshiAndHiroshi5-a6c3e7d3307c1e9559348ef277b3c011.webp";